import { createContext } from 'react';

export const ChatContext = createContext();
// export const CommentContext = createContext();
